import type {
  ApolloCache,
  ApolloClient,
  NormalizedCacheObject,
} from '@apollo/client';
import type { Brand, Country } from '@seek/audience-zones';
import { createClient } from '@seek/ca-graphql-client';
import type { browserHttpLink } from '@seek/ca-graphql-client/browser';
import type { nodeHttpLink } from '@seek/ca-graphql-client/node';

import type { Environment } from 'src/types/types';

import { getOverridedCandidateGraphEndpoint } from './getOverridedCandidateGraphEndpoint';

// Developer Note: Avoid environment detection (e.g., typeof window === 'undefined') in this function.
// This utility is called by both server and client code. Pass environment-specific parameters
// from their respective entry points: server.tsx for server-side params, client.tsx for client-side params.
export const configureApolloClient = ({
  appName,
  headers,
  brand,
  country,
  httpLink,
  environment,
  cache,
  ssrMode,
}: {
  appName: string;
  headers?: Record<string, string>;
  brand: Brand;
  country: Country;
  httpLink: typeof browserHttpLink | typeof nodeHttpLink;
  environment: Environment;
  cache?: ApolloCache<NormalizedCacheObject>;
  ssrMode: boolean;
}): ApolloClient<NormalizedCacheObject> =>
  createClient({
    appName,
    brand,
    country,
    httpLink,
    authOptions: {
      useAuth: true,
    },
    graphqlEndpointOverride: getOverridedCandidateGraphEndpoint(environment),
    ssrMode,
    headers,
    cache,
  });
